module.exports = __webpack_public_path__ + "img/14.34a75711.webp";